/*
 * Configuration
 */

// General Settings
export const TIMEZONES_REQUEST = 'TIMEZONES_REQUEST';
export const TIMEZONES_SUCCESS = 'TIMEZONES_SUCCESS';
export const LOCALES_REQUEST = 'LOCALES_REQUEST';
export const LOCALES_SUCCESS = 'LOCALES_SUCCESS';

/*
 * Users & Security
 */

// Login Security
export const SS_CENTER_SIGN_IN_PERMISSIONS_GROUPS_REQUEST = 'SS_CENTER_SIGN_IN_PERMISSIONS_GROUPS_REQUEST';
export const SS_CENTER_SIGN_IN_PERMISSIONS_GROUPS_SUCCESS = 'SS_CENTER_SIGN_IN_PERMISSIONS_GROUPS_SUCCESS';

export const SS_USERS_SUCCESS = 'SS_USERS_SUCCESS';
export const SS_ROLES_REQUEST = 'SS_ROLES_REQUEST';
export const SS_ROLES_SUCCESS = 'SS_ROLES_SUCCESS';
export const SS_ASSIGN_PERMISSIONS_REQUEST = 'SS_ASSIGN_PERMISSIONS_REQUEST';
export const SS_ASSIGN_PERMISSIONS_SUCCESS = 'SS_ASSIGN_PERMISSIONS_SUCCESS';
export const SS_PERMISSIONS_DISPOSE = 'SS_PERMISSIONS_DISPOSE';

export const MIN_SEARCH_LEN = 3;

// Annotation Library
export const UPDATE_ANNOTATIONS_LIBRARY_REQUEST = 'UPDATE_ANNOTATIONS_LIBRARY_REQUEST';
export const UPDATE_ANNOTATIONS_LIBRARY_SUCCESS = 'UPDATE_ANNOTATIONS_LIBRARY_SUCCESS';
export const ANNOTATIONS_GROUPS_REQUEST = 'ANNOTATIONS_GROUPS_REQUEST';
export const ANNOTATIONS_GROUPS_SUCCESS = 'ANNOTATIONS_GROUPS_SUCCESS';
export const ANNOTATIONS_ICONS_REQUEST = 'ANNOTATIONS_ICONS_REQUEST';
export const ANNOTATIONS_ICONS_SUCCESS = 'ANNOTATIONS_ICONS_SUCCESS';

// Capture Hosts
export const SS_CAPTURE_HOST_REQUEST = 'SS_CAPTURE_HOST_REQUEST';
export const SS_CAPTURE_HOST_SUCCESS = 'SS_CAPTURE_HOST_SUCCESS';
export const SS_CAPTURE_HOSTS_EXPORT_REQUEST = 'SS_CAPTURE_HOSTS_EXPORT_REQUEST';
export const SS_CAPTURE_HOSTS_EXPORT_SUCCESS = 'SS_CAPTURE_HOSTS_EXPORT_SUCCESS';

export const SS_LIBRARIES_SUCCESS = 'SS_LIBRARIES_SUCCESS';

export const DISPOSE_SS_ANNOTATIONS_STORE = 'DISPOSE_SS_ANNOTATIONS_STORE';
export const DISPOSE_SS_GENERAL_SETTINGS_STORE = 'DISPOSE_SS_GENERAL_SETTINGS_STORE';
export const DISPOSE_SS_LIBRARIES_STORE = 'DISPOSE_SS_LIBRARIES_STORE';

//#region UI Routes

export const SETUP_GENERAL_ROUTE = '/setup/general';
export const SETUP_GENERAL_EDIT_ROUTE = '/setup/general/edit';

export const SETUP_SP_MANAGEMENT_ROUTE = '/setup/sps';
export const SETUP_SP_MANAGEMENT_EDIT_ROUTE = '/setup/sps/edit';

export const SETUP_LOCATIONS_ROUTE = '/setup/locations';
export const SETUP_LOCATIONS_EDIT_ROUTE = '/setup/locations/edit';
export const getSetupLocationEditDevicesRoute = (locationId: string) => `/setup/locations/edit/devices/${locationId}`;

export const SETUP_ORGANIZATIONS_ROUTE = '/setup/organizations';
export const SETUP_ORGANIZATIONS_EDIT_ROUTE = '/setup/organizations/edit';

export const SETUP_QUESTION_CATEGORIES_ROUTE = '/setup/question-categories';
export const SETUP_QUESTION_CATEGORIES_EDIT_ROUTE = '/setup/question-categories/edit';

export const SETUP_LOGIN_SECURITY_ROUTE = '/setup/login-security';
export const SETUP_LOGIN_SECURITY_EDIT_ROUTE = '/setup/login-security/edit';

export const SETUP_SESSIONS_ROUTE = '/setup/sessions';
export const SETUP_SESSIONS_EDIT_ROUTE = '/setup/sessions/edit';

export const SETUP_USERS_ROUTE = '/setup/users';
export const SETUP_USERS_EDIT_ROUTE = '/setup/users/edit';

export const SETUP_SCENARIOS_ROUTE = '/setup/scenarios';
export const SETUP_SCENARIOS_EDIT_ROUTE = '/setup/scenarios/edit';

export const SETUP_COURSES_ROUTE = '/setup/courses';
export const SETUP_COURSES_EDIT_ROUTE = '/setup/courses/edit';

export const SETUP_GUDRID_REGISTER_ROUTE = '/setup/gudrid/register';
export const getSetupGudridPatientMonitorRoute = (patientMonitorId: string) =>
    `/setup/gudrid/patient-monitor/${patientMonitorId}`;
export const SETUP_GUDRID_PATIENT_MONITOR_LIST_ROUTE = '/setup/gudrid/patient-monitor';

export const SETUP_CALENDAR_ROUTE = '/setup/calendar';
export const SETUP_CALENDAR_EDIT_ROUTE = '/setup/calendar/edit';

export const SETUP_CENTER_SIGN_IN_ROUTE = '/setup/center-sign-in';
export const SETUP_CENTER_SIGN_IN_EDIT_ROUTE = '/setup/center-sign-in/edit';

export const SETUP_ANNOTATIONS_ROUTE = '/setup/annotations-library';
export const SETUP_ANNOTATIONS_EDIT_ROUTE = '/setup/annotations-library/edit';

export const SETUP_CAPTURE_HOSTS_ROUTE = '/setup/recording-devices';
export const SETUP_CAPTURE_HOSTS_REGISTER_ROUTE = '/setup/recording-devices/register';
export const getSetupCaptureHostsEditRoute = (captureHostId: string) => `/setup/recording-devices/${captureHostId}`;

export const SETUP_SIMULATORS_ROUTE = '/setup/simulators';
export const SETUP_SIMULATORS_REGISTER_ROUTE = '/setup/simulators/register';
export const getSetupSimulatorsEditRoute = (simulatorId: string) => `/setup/simulators/${simulatorId}`;

export const SETUP_APPLICATIONS_ROUTE = '/setup/applications';
export const SETUP_APPLICATIONS_REGISTER_ROUTE = '/setup/applications/register';
export const getSetupApplicationsEditRoute = (applicationId: string) => `/setup/applications/${applicationId}`;

export const SETUP_IP_VIDEO_FEEDS_ROUTE = '/setup/ip-video-feeds';
export const SETUP_IP_VIDEO_FEEDS_REGISTER_ROUTE = '/setup/ip-video-feeds/register';
export const SETUP_IP_VIDEO_FEEDS_IMPORT_ROUTE = '/setup/ip-video-feeds/import';
export const getSetupIpVideoFeedsEditRoute = (ipVideoFeedId: string) => `/setup/ip-video-feeds/${ipVideoFeedId}`;

export const SETUP_IP_AUDIO_FEEDS_ROUTE = '/setup/ip-audio-feeds';
export const SETUP_IP_AUDIO_FEEDS_REGISTER_ROUTE = '/setup/ip-audio-feeds/register';
export const getSetupIpAudioFeedsEditRoute = (ipAudioFeedId: string) => `/setup/ip-audio-feeds/${ipAudioFeedId}`;

export const SETUP_VERSIONS_SUPPORT_ROUTE = '/setup/about';
export const SETUP_LIBRARIES_ROUTE = '/setup/about/libraries';

export const SETUP_EXAMS_ROUTE = '/setup/exams';
export const SETUP_EXAMS_EDIT_ROUTE = '/setup/exams/edit';
export const SETUP_EXAMS_REGISTER_ROUTE = '/setup/exams/register';

export const SETUP_EXAM_FLOW_LIBRARY_ROUTE = '/setup/exam-flows';
export const SETUP_EXAM_FLOW_LIBRARY_EDIT_ROUTE = '/setup/exam-flows/edit';

export const SETUP_HONOR_CODE_ROUTE = '/setup/honor-codes';
export const getHonorCodeEditRoute = (honorCodeId) => `/setup/honor-codes/${honorCodeId}/edit`;
export const SETUP_HONOR_CODE_NEW_ROUTE = '/setup/honor-codes/new';

export const SETUP_EXAM_PERMISSIONS_ROUTE = '/setup/exams-permissions';
export const SETUP_EXAM_PERMISSIONS_EDIT_ROUTE = '/setup/exams-permissions/edit';

export const SETUP_LAYOUTS_ROUTE = '/setup/layouts';
export const SETUP_LAYOUTS_EDIT_ROUTE = '/setup/layouts/edit';
export const APP_FEATURES_ROUTE = '/setup/app-features';
export const APP_FEATURES_EDIT_ROUTE = '/setup/app-features/edit';

export const SETUP_LAYOUT_BUILDER_ROUTE = '/setup/layout-builder';

export const SIMCAPTURE_KNOWLEDGE_BASE_COMPUTER_REQUIREMENTS_LINK =
    'https://help.simcapture.com/en_US/technical-information/simcapture-client-furnished-equipment-cfe-specifications';

export const SETUP_SAMARITAN = '/setup/samaritan';
export const SETUP_SAMARITAN_CONFIGURE = '/setup/samaritan/configure';
export const SETUP_SAMARITAN_CONFIGURE_EVALUATION_BUILDER = `${SETUP_SAMARITAN_CONFIGURE}/evaluation-builder`;
export const SETUP_SAMARITAN_CONFIGURE_TRANSCRIPTION = `${SETUP_SAMARITAN_CONFIGURE}/transcription`;
export const SETUP_SAMARITAN_CONFIGURE_SP_INTER_RATER = `${SETUP_SAMARITAN_CONFIGURE}/sp-inter-rater`;

export const SETUP_SSO_ROUTE = '/setup/sso';
export const SETUP_SSO_EDIT_ROUTE = '/setup/sso/edit';

export const SETUP_NETWORK_SOURCES_ROUTE = '/setup/network-sources';

export const SETUP_AUDIO_MESSAGES_ROUTE = '/setup/audio-messages';
export const SETUP_AUDIO_MESSAGES_NEW_ROUTE = '/setup/audio-messages/new';
export const getAudioMessageEditRoute = (audioMessageId: string) => `/setup/audio-messages/${audioMessageId}/edit`;

export const SETUP_MOBILE_RECORD_ROUTE = '/setup/mobile-record';
export const SETUP_MOBILE_RECORD_NEW_ROUTE = '/setup/mobile-record/new';
export const getMobileRecordEditRoute = (mobileRecordDeviceId: string) =>
    `/setup/mobile-record/${mobileRecordDeviceId}/edit`;

export const SETUP_LMS_ROUTE = '/setup/lms';
export const SETUP_LMS_EDIT_ROUTE = '/setup/lms/edit';

//#endregion

export interface Listing {
    id: string;
    default?: boolean;
}

interface SessionTimeoutListing extends Listing {
    timeout: number;
}

// calculated in seconds
const SESSION_TIMEOUT: SessionTimeoutListing[] = [
    {
        timeout: 600,
        id: 'tenMinutes',
    },
    {
        timeout: 900,
        id: 'quarterHour',
    },
    {
        timeout: 1800,
        id: 'halfHour',
    },
    {
        timeout: 3600,
        id: 'hour',
    },
    {
        timeout: 10800,
        id: 'threeHours',
    },
    {
        timeout: 43200,
        id: 'twelveHours',
    },
    {
        default: true,
        timeout: 86400,
        id: 'day',
    },
];

interface TimeoutWarningListing extends Listing {
    warning: number;
}

// calculated in seconds
const TIMEOUT_WARNING: TimeoutWarningListing[] = [
    {
        warning: 10,
        id: 'tenSeconds',
        default: true,
    },
    {
        warning: 30,
        id: 'thirtySeconds',
    },
    {
        warning: 60,
        id: 'minute',
    },
];

interface LoginLockoutTimeListing extends Listing {
    lockout: number;
}

const LOGIN_LOCKOUT_TIME: LoginLockoutTimeListing[] = [
    {
        lockout: 30,
        id: 'halfMinute',
    },
    {
        lockout: 60,
        id: 'minute',
    },
    {
        lockout: 180,
        id: 'threeMinutes',
    },
    {
        lockout: 600,
        id: 'tenMinutes',
        default: true,
    },
    {
        lockout: 3600,
        id: 'hour',
    },
    {
        lockout: 43200,
        id: 'halfDay',
    },
    {
        lockout: 86400,
        id: 'day',
    },
];

interface LoginIncorrectAttemptsListing extends Listing {
    incorrect: number;
}

const LOGIN_INCORRECT_ATTEMPTS: LoginIncorrectAttemptsListing[] = [
    {
        incorrect: 0,
        id: 'none',
        default: true,
    },
    {
        incorrect: 1,
        id: 'one',
    },
    {
        incorrect: 3,
        id: 'three',
    },
    {
        incorrect: 5,
        id: 'five',
    },
    {
        incorrect: 10,
        id: 'ten',
    },
];

interface PasswordExpirationListing extends Listing {
    expiration: number;
}

// calculated in minutes
const PASSWORD_EXPIRATION: PasswordExpirationListing[] = [
    {
        expiration: 0,
        id: 'none',
        default: true,
    },
    {
        expiration: 10080,
        id: 'weekly',
    },
    {
        expiration: 20160,
        id: 'biWeekly',
    },
    {
        expiration: 43800,
        id: 'monthly',
    },
    {
        expiration: 87600,
        id: 'biMonthly',
    },
    {
        expiration: 131400,
        id: 'threeMonths',
    },
    {
        expiration: 262800,
        id: 'semiAnnually',
    },
    {
        expiration: 525600,
        id: 'yearly',
    },
];

interface PasswordStrengthListing extends Listing {
    strength: number;
}

const PASSWORD_STRENGTH: PasswordStrengthListing[] = [
    {
        strength: 1,
        id: 'none',
        default: true,
    },
    {
        strength: 2,
        id: 'medium',
    },
    {
        strength: 3,
        id: 'strong',
    },
];

export type SearchKey =
    | 'sessionTimeoutSeconds'
    | 'timeoutWarningSeconds'
    | 'loginIncorrectAttempts'
    | 'loginLockoutTimeSeconds'
    | 'passwordExpirationMinutes'
    | 'passwordStrength';

export type LoginSecuritySettingKey =
    | SearchKey
    | 'allowSsoLogin'
    | 'allowLocalLogin'
    | 'allowSsoExamLogin'
    | 'allowLocalExamLogin'
    | 'ssoEnabled';

export type LoginSecuritySettings = {
    sessionTimeoutSeconds: number;
    timeoutWarningSeconds: number;
    loginIncorrectAttempts: number;
    loginLockoutTimeSeconds: number;
    passwordExpirationMinutes: number;
    passwordStrength: number;
    ssoEnabled: boolean;
    allowSsoLogin: boolean;
    allowLocalLogin: boolean;
    allowSsoExamLogin: boolean | null;
    allowLocalExamLogin: boolean | null;
};

export type Prefix = 'timeout' | 'warning' | 'incorrect' | 'lockout' | 'expiration' | 'strength';

export type SecurityConstant = {
    listing: Readonly<Listing>[];
    searchKey: SearchKey;
    prefix: Prefix;
};

export const SECURITY_CONSTANTS = Object.freeze<SecurityConstant[]>([
    {
        listing: SESSION_TIMEOUT,
        searchKey: 'sessionTimeoutSeconds',
        prefix: 'timeout',
    },
    {
        listing: TIMEOUT_WARNING,
        searchKey: 'timeoutWarningSeconds',
        prefix: 'warning',
    },
    {
        listing: LOGIN_INCORRECT_ATTEMPTS,
        searchKey: 'loginIncorrectAttempts',
        prefix: 'incorrect',
    },
    {
        listing: LOGIN_LOCKOUT_TIME,
        searchKey: 'loginLockoutTimeSeconds',
        prefix: 'lockout',
    },
    {
        listing: PASSWORD_EXPIRATION,
        searchKey: 'passwordExpirationMinutes',
        prefix: 'expiration',
    },
    {
        listing: PASSWORD_STRENGTH,
        searchKey: 'passwordStrength',
        prefix: 'strength',
    },
]);

export const SECURITY_CONSTANTS_TEST = Object.freeze<SecurityConstant[]>([
    {
        listing: [
            {
                timeout: 30,
                id: 'test',
            },
            ...SESSION_TIMEOUT,
        ],
        searchKey: 'sessionTimeoutSeconds',
        prefix: 'timeout',
    },
    {
        listing: TIMEOUT_WARNING,
        searchKey: 'timeoutWarningSeconds',
        prefix: 'warning',
    },
    {
        listing: LOGIN_INCORRECT_ATTEMPTS,
        searchKey: 'loginIncorrectAttempts',
        prefix: 'incorrect',
    },
    {
        listing: [
            {
                lockout: 10,
                id: 'test',
            },
            ...LOGIN_LOCKOUT_TIME,
        ],
        searchKey: 'loginLockoutTimeSeconds',
        prefix: 'lockout',
    },
    {
        listing: [
            {
                expiration: 1,
                id: 'test',
            },
            ...PASSWORD_EXPIRATION,
        ],
        searchKey: 'passwordExpirationMinutes',
        prefix: 'expiration',
    },
    {
        listing: PASSWORD_STRENGTH,
        searchKey: 'passwordStrength',
        prefix: 'strength',
    },
]);

export const ROOM_DND_TYPE = 'ROOM';
export const RESIZE_DND_TYPE = 'RESIZE';

export const DEFAULT_LMS_MEMBERSHIPS_REQUEST_LIMIT = 50;
export const DEFAULT_LMS_MEMBERSHIPS_COURSE_LIMIT = 2500;

export const DEFAULT_LMS_LINE_ITEMS_REQUEST_LIMIT = 50;
export const DEFAULT_LMS_LINE_ITEMS_COURSE_LIMIT = 200;

export const DEFAULT_LMS_SCORES_REQUEST_LIMIT = 100;
export const DEFAULT_LMS_SCORES_COURSE_LIMIT = 10_000;

export const MAX_LMS_LIMIT = 10_000;
